import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "night",
  "use": "night-usage",
  "viewBox": "0 0 10.511 14.118",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.511 14.118\" id=\"night\"><defs><style>#night .a{fill:none;stroke:#342f41;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.2px;}</style></defs><path class=\"a\" d=\"M6.2,6.959A6.453,6.453,0,0,1,9.811,1.17,6.456,6.456,0,1,0,6.959,13.418a6.422,6.422,0,0,0,2.852-.671A6.451,6.451,0,0,1,6.2,6.959Z\" transform=\"translate(0.1 0.1)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol